var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRulesUsp4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_548_23)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 32,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_548_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5023 18C36.0162 18.0117 36.3949 18.2539 36.6229 18.7227C37.4344 20.3867 38.2458 22.0508 39.0573 23.7148C39.3703 24.3555 39.691 24.9961 39.9962 25.6406C40.2783 26.2422 40.7497 26.5508 41.3912 26.6445C43.1378 26.8945 44.8805 27.1523 46.627 27.4102C47.3728 27.5195 48.1147 27.6328 48.8605 27.7383C49.3628 27.8086 49.7299 28.0625 49.9076 28.5469C50.0893 29.043 50.0004 29.5039 49.6256 29.8789C48.4354 31.0625 47.2376 32.2344 46.0435 33.4102C45.3751 34.0703 44.6988 34.7188 44.0381 35.3867C43.6555 35.7734 43.5087 36.2578 43.6014 36.8008C44.0342 39.3594 44.467 41.918 44.9036 44.4766C44.9925 45 44.8418 45.4336 44.4168 45.75C43.9994 46.0586 43.5435 46.0781 43.0875 45.8359C40.9159 44.6836 38.7443 43.5312 36.5727 42.375C36.4761 42.3242 36.3795 42.2734 36.2829 42.2227C35.7612 41.9414 35.2357 41.9414 34.714 42.2227C33.0216 43.125 31.3291 44.0234 29.6366 44.9219C29.0686 45.2266 28.4967 45.5273 27.9248 45.8281C27.4611 46.0742 27.0052 46.0664 26.5763 45.75C26.1435 45.4297 26.0005 44.9922 26.0932 44.4609C26.5299 41.9102 26.9588 39.3555 27.3916 36.8047C27.4882 36.2422 27.3259 35.7539 26.9279 35.3594C25.8459 34.2812 24.7524 33.2148 23.6627 32.1445C22.9054 31.3984 22.148 30.6562 21.3945 29.9062C21.0158 29.5273 20.8999 29.0742 21.0777 28.5625C21.2554 28.0586 21.6302 27.8047 22.148 27.7305C23.9564 27.4688 25.7648 27.1992 27.5732 26.9297C28.2996 26.8242 29.0261 26.7227 29.7487 26.6094C30.2935 26.5234 30.6992 26.2266 30.9465 25.7227C31.843 23.8906 32.7395 22.0586 33.6321 20.2266C33.8794 19.7188 34.1228 19.207 34.3779 18.7031C34.6136 18.2461 34.9884 18.0117 35.5023 18Z",
    fill: "#A48242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_548_23",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_548_23"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_548_23",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_548_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28,
    fill: "white",
    transform: "translate(21 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesUsp4);
export default __webpack_public_path__ + "static/media/rules-usp4.14a5082ed1f8b78056d769176ffaee21.svg";
export { ForwardRef as ReactComponent };